<template>
    <div class="head-box">
        <prosess v-if="templalteIntro && templalteIntro.isStepPage">
        </prosess>
        <logo v-else :templalteIntro="templalteIntro"></logo>
    </div>
</template>

<script>
import logo from "@/components/onBody/components/logo";
import prosess from "@/components/onBody/components/prosess";

export default {
    computed: {
        templalteIntro() {
            return this.$store.getters.currentTemplateFlow
        }
    },
    components: {
        prosess,
        logo
    },
    methods: {

    },
};
</script>

<style scoped></style>